export default "__VITE_PUBLIC_ASSET__dad36d6c__"